import { useNavigate } from "react-router-dom";
import { LuCalendarClock, LuWallet, LuPauseCircle, LuArrowRight } from "react-icons/lu";
import StarIcon from "../../ui/StarIcon";
import * as styled from "./WelcomeCard.styled";

const DAYS = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
const DAY_NAMES = {
  monday: "Понеділок",
  tuesday: "Вівторок",
  wednesday: "Середа",
  thursday: "Четвер",
  friday: "П'ятниця",
  saturday: "Субота",
  sunday: "Неділя",
};

// Найближчий урок за постійним розкладом учня (переноси тут не враховуються)
const findNextLesson = (schedule = [], now = new Date()) => {
  const minutesNow = now.getHours() * 60 + now.getMinutes();
  let best = null;

  schedule.forEach(({ day, time }) => {
    const dayIndex = DAYS.indexOf(day);
    if (dayIndex === -1 || !time) return;
    const [hours, minutes] = time.split(":").map(Number);
    let daysAhead = (dayIndex - now.getDay() + 7) % 7;
    if (daysAhead === 0 && hours * 60 + minutes <= minutesNow) daysAhead = 7;
    const score = daysAhead * 1440 + hours * 60 + minutes;
    if (!best || score < best.score) best = { day, time, daysAhead, score };
  });

  return best;
};

const whenLabel = ({ day, daysAhead }) => {
  if (daysAhead === 0) return "Сьогодні";
  if (daysAhead === 1) return "Завтра";
  return DAY_NAMES[day];
};

function WelcomeCard({ data, isTrial }) {
  const navigate = useNavigate();
  const base = isTrial ? "/trial-student" : "/student";
  const next = findNextLesson(data.classSchedule);
  const firstName = (data.name || "").split(" ")[0];

  return (
    <styled.Card>
      <styled.Main>
        <styled.Hello>Привіт, {firstName}!</styled.Hello>

        {data.isPaused ? (
          <styled.Next>
            <styled.NextIcon>
              <LuPauseCircle size={22} />
            </styled.NextIcon>
            <div>
              <styled.NextLabel>Навчання на паузі</styled.NextLabel>
              <styled.NextValue>Чекаємо на тебе знову</styled.NextValue>
            </div>
          </styled.Next>
        ) : next ? (
          <styled.Next>
            <styled.NextIcon>
              <LuCalendarClock size={22} />
            </styled.NextIcon>
            <div>
              <styled.NextLabel>Найближчий урок</styled.NextLabel>
              <styled.NextValue>
                {whenLabel(next)}, {next.time}
              </styled.NextValue>
            </div>
          </styled.Next>
        ) : null}

        <styled.Action onClick={() => navigate(`${base}/schedule`)}>
          Мій розклад <LuArrowRight size={18} />
        </styled.Action>
      </styled.Main>

      {!isTrial && (
        <styled.Stats>
          <styled.Stat onClick={() => navigate(`${base}/shop`)}>
            <styled.StatValue>
              {data.stars ?? 0} <StarIcon size={22} />
            </styled.StatValue>
            <styled.StatLabel>зірок</styled.StatLabel>
          </styled.Stat>
          <styled.Stat onClick={() => navigate(`${base}/payment`)}>
            <styled.StatValue>
              {data.totalLessons ?? 0} <LuWallet size={20} />
            </styled.StatValue>
            <styled.StatLabel>уроків залишилось</styled.StatLabel>
          </styled.Stat>
        </styled.Stats>
      )}
    </styled.Card>
  );
}

export default WelcomeCard;
